<template>
  <el-card shadow="never"
           class="aui-card--fill">
    <el-form :model="dataForm"
             :rules="dataRule"
             ref="dataForm"
             label-position="top">
      <el-form-item prop="type"
                    :label="$t('menu.type')"
                    size="mini">
        <el-radio-group v-model="dataForm.type"
                        :disabled="!!dataForm.menuId"
                        @change="typeChange">
          <el-radio :label="0">{{ $t('menu.type0') }}</el-radio>
          <el-radio :label="1">{{ $t('menu.type1') }}</el-radio>
          <el-radio :label="2">{{ $t('menu.type2') }}</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-row class="">
        <el-col :span="6"
                class="marb">
          <el-form-item prop="name"
                        :label="$t('menu.name')">
            <el-input v-model="dataForm.name"
                      :placeholder="$t('menu.name')"
                      class="maxwidth"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6"
                class="marb"
                v-if="dataForm.type !== 0">
          <el-form-item prop="parentName"
                        :label="$t('menu.parentName')"
                        class="menu-list">
            <el-popover v-model="menuListVisible"
                        ref="menuListPopover"
                        placement="bottom-start"
                        trigger="click">
              <el-tree :data="menuList"
                       class="overflow-pop"
                       :props="{ label: 'name', isLeaf: 'leaf' }"
                       lazy
                       :load="getChildList"
                       node-key="menuId"
                       ref="menuListTree"
                       :highlight-current="true"
                       :expand-on-click-node="false"
                       accordion
                       @current-change="menuListTreeCurrentChangeHandle">
              </el-tree>
            </el-popover>
            <el-input v-model="dataForm.parentName"
                      v-popover:menuListPopover
                      :readonly="true"
                      :placeholder="$t('menu.parentName')"
                      class="maxwidth">
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6"
                class="marb"
                v-if="dataForm.type === 0">
          <el-form-item prop="sysCode"
                        :label="$t('menu.sysCode')">
            <el-select v-model="dataForm.sysCode"
                       :placeholder="$t('menu.sysCode')"
                       clearable
                       class="maxwidth">
              <el-option v-for="(item,index) in sysCodeArr"
                         :key="index"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6"
                class="marb">
          <el-form-item prop="orderNum"
                        :label="$t('menu.orderNum')">
            <el-input v-model="dataForm.orderNum"
                      :label="$t('menu.orderNum')"
                      @input="handleClickOrderNum"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6"
                class="marb"
                v-if="dataForm.type !== 2">
          <el-form-item prop="icon"
                        :label="$t('menu.icon')"
                        class="icon-list">
            <el-popover v-model="iconListVisible"
                        ref="iconListPopover"
                        placement="bottom-start"
                        trigger="click"
                        popper-class="mod-sys__menu-icon-popover">
              <div class="mod-sys__menu-icon-inner">
                <div class="mod-sys__menu-icon-list">
                  <el-button v-for="(item, index) in iconList"
                             :key="index"
                             @click="iconListCurrentChangeHandle(item)"
                             :class="{ 'is-active': dataForm.icon === item }">
                    <svg class="icon-svg"
                         aria-hidden="true">
                      <use :xlink:href="`#${item}`"></use>
                    </svg>
                  </el-button>
                </div>
              </div>
            </el-popover>
            <el-input v-model="dataForm.icon"
                      v-popover:iconListPopover
                      :readonly="true"
                      :placeholder="$t('menu.icon')"
                      class="maxwidth"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6"
                class="marb"
                v-if="dataForm.type === 1">
          <el-form-item prop="url"
                        :label="$t('menu.url')">
            <el-input v-model="dataForm.url"
                      :placeholder="$t('menu.permissionsTips')"
                      class="maxwidth"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6"
                class="marb"
                v-if="dataForm.type !== 2">
          <el-form-item prop="hide"
                        :label="$t('menu.hide')">
            <el-select v-model="dataForm.hide"
                       :placeholder="$t('menu.hide')">
              <el-option v-for="item in hideOptions"
                         :key="item.code"
                         :label="item.name"
                         :value="item.code">
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6"
                class="marb"
                v-if="dataForm.type !== 0">
          <el-form-item prop="urls"
                        :label="$t('menu.permissions')">
            <el-input v-model="dataForm.urls"
                      :placeholder="$t('menu.permissions')"
                      class="maxwidth"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6"
                class="marb"
                v-if="dataForm.type === 2">
          <el-form-item prop="perms"
                        :label="$t('menu.perms')">
            <el-input v-model="dataForm.perms"
                      :placeholder="$t('menu.perms')"
                      class="maxwidth"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div style="margin-top: 10px">
      <el-button type="primary"
                 class="location-layout"
                 @click="dataFormSubmitHandle()">{{ $t('user.save') }}</el-button>
      <el-button class="location-layout"
                 @click="back()">{{ $t('user.back') }}</el-button>
    </div>
  </el-card>
</template>
<script>
import { getIconList } from '@/utils'
import debounce from 'lodash/debounce'
import $ from 'jquery'
export default {
  data() {
    let _this = this
    return {
      sysCodeArr: _this.enums['sysCode'], // 子系统
      hideOptions: _this.enums['hide'], // 是否显示
      menuList: [],
      menuListVisible: false,
      iconList: [],
      iconListVisible: false,
      dataForm: {
        menuId: '',
        type: 1,
        name: '',
        sysCode: '',
        parentId: '0',
        parentName: '',
        url: '',
        urls: '',
        resourceList: [],
        permissions: '',
        orderNum: '0',
        hide: '1',
        icon: ''
      }
    }
  },
  computed: {
    dataRule() {
      return {
        name: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: this.$validate.isSpecial, trigger: 'blur' },
          { max: 10, message: this.$t('validate.validateLength', { 'handle': '10' }), trigger: 'blur' },
          { validator: this.$validate.isSpecialCharactersPosition, trigger: 'blur' }
        ],
        parentName: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        sysCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        hide: [
          { required: true, message: this.$t('validate.required'), trigger: 'change' }
        ],
        url: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: this.$validate.isSpecial, trigger: 'blur' },
          { max: 1000, message: this.$t('validate.validateLength', { 'handle': '50' }), trigger: 'blur' }
        ],
        orderNum: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 11, message: this.$t('validate.validateLength', { 'handle': '11' }), trigger: 'blur' }
        ],
        urls: [
          // { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { max: 1000, message: this.$t('validate.validateLength', { 'handle': '1000' }), trigger: 'blur' }
        ],
        perms: [
          { max: 200, message: this.$t('validate.validateLength', { 'handle': '200' }), trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.$eventHub.$on(this.GLOBAL.ACTIVATED_MENU, (data) => {
      if (this.$refs.dataForm) {
        this.dataForm.menuId = null
        this.$refs['dataForm'].resetFields()
        this.initialization()
      }
    })
  },
  mounted() {
    this.initialization()
  },
  // activated () {
  //   this.$nextTick(() => {
  //     this.$refs['dataForm'].resetFields()
  //     this.iconList = getIconList()
  //     this.getMenuList().then(() => {
  //       if (this.$route.query.menuId !== undefined) {
  //         this.dataForm.menuId = this.$route.query.menuId
  //         this.getInfo()
  //       }
  //     })
  //   })
  // },
  methods: {
    initialization() {
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        this.iconList = getIconList()
        this.getMenuList().then(() => {
          if (this.$route.query.menuId !== undefined) {
            this.dataForm.menuId = this.$route.query.menuId
            this.getInfo()
          }
        })
        $('.overflow-pop').closest('.el-popover').css({ 'max-height': '250px', 'overflow-y': 'auto' })
      })
    },
    typeChange() {
      this.$refs['dataForm'].clearValidate()
      this.dataForm.menuId = ''
      this.dataForm.name = ''
      this.dataForm.sysCode = ''
      this.dataForm.parentId = '0'
      this.dataForm.parentName = ''
      this.dataForm.url = ''
      this.dataForm.resourceList = []
      this.dataForm.permissions = ''
      this.dataForm.orderNum = '0'
      this.dataForm.hide = '1'
      this.dataForm.icon = ''
      this.dataForm.urls = ''
      this.getMenuList()
      $('.overflow-pop').closest('.el-popover').css({ 'max-height': '250px', 'overflow-y': 'auto' })
    },
    handleClickOrderNum() {
      // eslint-disable-next-line no-useless-escape
      this.dataForm.orderNum = this.dataForm.orderNum.replace(/[^\.\d]/g, '')
      this.dataForm.orderNum = this.dataForm.orderNum.replace('.', '')
    },
    // 异步获取菜单下级
    getChildList(tree, resolve) {
      this.getTreeChild(tree.data.menuId, resolve)
    },
    getTreeChild(menuId, resolve) {
      this.$request.get(
        '/sys/menu/getChildrenlist',
        {
          menuId: menuId
        }
      ).then((res) => {
        if (this.$route.query.menuId) {
          for (let i = 0; i < res.length; i++) {
            if (res[i].menuId === this.$route.query.menuId) {
              let index = res.indexOf(res[i])
              if (index > -1) {
                res.splice(index, 1)
              }
            }
          }
        }
        resolve(res)
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取菜单列表
    getMenuList() {
      return this.$request.get(
        '/sys/menu/list', {
        type: this.dataForm.type
      }
      ).then((res) => {
        this.menuList = res
      }).catch((err) => {
        console.log(err)
      })
    },
    getMenuListMerga(type) {
      return this.$request.get(
        '/sys/menu/list', {
        type: type
      }
      ).then((res) => {
        this.menuList = res
        if (this.dataForm.parentId === 0) {
          // return this.deptListTreeSetDefaultHandle()
        } else {
          this.$refs.menuListTree.setCurrentKey(this.dataForm.parentId)
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取信息
    getInfo() {
      this.$request.get(`/sys/menu/info/${this.dataForm.menuId}`).then((res, total, code, data) => {
        res.orderNum = res.orderNum + ''
        this.dataForm = {
          ...this.dataForm,
          ...res
        }
        this.getMenuListMerga(res.type)
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      }).catch((err) => {
        console.log(err)
      })
    },
    // 上级菜单树, 设置默认值
    // deptListTreeSetDefaultHandle () {
    //   this.dataForm.pid = '0'
    //   this.dataForm.parentName = this.$t('menu.parentNameDefault')
    // },
    // 上级菜单树, 选中
    menuListTreeCurrentChangeHandle(data) {
      this.dataForm.parentId = data.menuId
      this.dataForm.parentName = data.name
      this.menuListVisible = false
    },
    // 图标, 选中
    iconListCurrentChangeHandle(icon) {
      this.dataForm.icon = icon
      this.iconListVisible = false
    },
    // 菜单资源, 添加
    resourceAddHandle() {
      this.dataForm.resourceList.push({
        key: new Date().getTime(),
        resourceMethod: 'GET',
        resourceUrl: ''
      })
    },
    // 菜单资源, 删除
    resourceDeleteHandle(resource) {
      this.dataForm.resourceList = this.dataForm.resourceList.filter(item => item.key !== resource.key)
    },
    // 表单提交
    dataFormSubmitHandle: debounce(
      function () {
        // dataFormSubmitHandle () {
        this.$refs['dataForm'].validate((valid) => {
          if (!valid) {
            return false
          }
          this.$request.post(`/sys/menu/${!this.dataForm.menuId ? 'save' : 'update'}`,
            this.dataForm
          ).then((res, total, code, data) => {
            this.$message({
              message: this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                this.tabRemove(this.$store.state.contentTabsActiveName)
                // this.back()
              }
            })
          }).catch((err) => {
            console.log(err)
          })
        })
      },
      2000,
      { leading: true, trailing: false }
    ),
    back() {
      this.$router.push({
        name: 'sys-menu'
      })
    },
    // 删除窗口
    tabRemove(tabName) {
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({
          name: 'sys-menu'
        })
      }
    }
  }
}

</script>
<style lang="scss" scoped>
.marb {
  margin-bottom: 10px;
}
.mod-sys__menu {
  .resource-list {
    .el-select .el-input__inner {
      min-width: 110px;
      text-align: center;
    }
  }
  .menu-list,
  .icon-list {
    .el-input__inner,
    .el-input__suffix {
      cursor: pointer;
    }
  }
  &-icon-popover {
    width: 458px;
    overflow: hidden;
  }
  &-icon-inner {
    width: 478px;
    max-height: 258px;
    overflow-x: hidden;
    overflow-y: auto;
  }
  &-icon-list {
    width: 458px;
    padding: 0;
    margin: -8px 0 0 -8px;
    > .el-button {
      padding: 8px;
      margin: 8px 0 0 8px;
      > span {
        display: inline-block;
        vertical-align: middle;
        width: 18px;
        height: 18px;
        font-size: 18px;
      }
    }
  }
}
// .el-popover .el-popper{
//   max-height: auto !important;
//   overflow-y: none !important;
// }
// .overflow-pop {
//   max-height: 250px;
//   overflow-y: auto;
// }
</style>
